import { clone, toLower, includes, compose, filter, curry, propOr, trim } from 'ramda';
const omit = 
// @ts-ignore-next-line
(property, obj) => Object.keys(obj).reduce((acc, key) => {
    if (key !== property) {
        acc[key] = obj[key];
    }
    return acc;
}, {});
const existsIn = (arr) => (item) => arr.includes(item);
const pluck = (property, arr) => arr.map(item => item[property]);
const isEmptyArray = (arr) => Array.isArray(arr) && arr.length <= 0;
const insertAll = (idx, elts, list) => ([
    ...list.slice(0, idx),
    ...elts,
    ...list.slice(idx),
]);
const insert = (idx, elm, list) => list.map((item, index) => index === idx ? elm : item);
const omitByIndex = (index, arr) => ([
    ...arr.slice(0, index),
    ...arr.slice(index + 1, arr.length),
]);
const setByIndex = (idx, elt, arr) => arr.map((item, index) => index === idx ? elt : item);
const deepClone = (obj) => clone(obj);
const takeLast = (count, arr) => arr.slice(Math.max(0, count >= 0 ? arr.length - count : 0), Infinity);
function isEmptyValue(value) {
    const isEmptyObject = (v) => Object.prototype.toString.call(v) === `[object Object]` &&
        v !== null &&
        Object.keys(v).length === 0;
    if (isEmptyArray(value) || isEmptyObject(value)) {
        return true;
    }
    if (value === 0 || value === false) {
        return false;
    }
    return !value;
}
const searchByProp = curry((property, searchText, arr) => filter(compose(includes(toLower(trim(searchText))), trim, toLower, (prop) => prop.toString(), propOr(``, property)), arr));
const processTimestamp = (timestamp, offset = 0) => +new Date((Number(timestamp || 0) * 1000) + offset);
export { omit, existsIn, pluck, isEmptyArray, insertAll, insert, omitByIndex, deepClone, setByIndex, takeLast, isEmptyValue, searchByProp, processTimestamp, };
